import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import Section from 'components/common/Section';
import Phone from '../Phone';
import Footer from '../Footer';
import Email from 'owl/Email';
import Name from 'owl/Name';
import PhoneAPC from 'owl/PhoneAPC';

const Terms = () => {
  return (
    <>
      <Section className="py-3" style={{ minHeight: 'calc(100vh - 200px)' }}>
        <Row className="flex-center p-0">
          <Col sm={10} lg={7} className="col-xxl-5">
            <Card>
              <Card.Body className="overflow-hidden p-lg-6">
                <Row className="align-items-center justify-content-between">
                  <Col lg={12} className="ps-lg-4 my-5 text-lg-start">
                    <h3 className="text-primary text-center">
                      Automated Project Coordinator
                    </h3>
                    <h4 className="text-center">Terms of Service</h4>
                    <h5 className="text-left">
                      Agreement to Receive Text Messages
                    </h5>
                    <p>
                      By providing your mobile number, you agree that <Name />{' '}
                      may send you periodic SMS or MMS messages containing (but
                      not limited to) information about orders and appointments.
                    </p>
                    <p>
                      You may unsubscribe at any time by texting the word STOP
                      to <PhoneAPC />. You may receive a subsequent message
                      message confirming your opt-out request.
                    </p>
                    <p>
                      For help, send the word HELP to <PhoneAPC />.
                    </p>
                    <p>
                      Message and data rates may apply. You can also receive
                      help by emailing <Email /> or calling <Phone />.
                    </p>
                    <p>
                      United States and Canada Participating Carriers include
                      AT&T, T-Mobile®, Verizon Wireless, Sprint, Boost, U.S.
                      Cellular®, MetroPCS®, InterOp, Cellcom, C Spire Wireless,
                      Cricket, Virgin Mobile and others.
                    </p>
                    <p>
                      Carriers and <Name /> are not liable for delayed or
                      undelivered messages.
                    </p>
                    <p>
                      You agree to notify us of any changes to your mobile
                      number and update your account with us to reflect this
                      change.
                    </p>
                    <p>
                      Data obtained from you in connection with this SMS service
                      may include your cell phone number, your carrier’s name,
                      and the date, time and content of your messages, as well
                      as other information that you provide. We may use this
                      information to contact you and to provide the services you
                      request from us.
                    </p>
                    <p>
                      By subscribing or otherwise using the text notification
                      service, you acknowledge and agree that we will have the
                      right to change and/or terminate the service at any time,
                      with or without cause and/or advance notice.
                    </p>
                    <p>
                      If you have any questions please email <Email /> or call{' '}
                      <Phone />.
                    </p>
                    <p>
                      Though <Name /> will never charge you for the text
                      messages you receive, depending on your phone plan, you
                      may see some charges from your mobile provider. Please
                      reach out to your wireless provider if you have questions
                      about your text or data plan.
                    </p>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Section>
      <Footer />
    </>
  );
};

export default Terms;
